import { useEffect, useMemo, useState } from 'react'
import { remove886, to886 } from '../../libs/utils'
import BulletButton from '../babu/BulletButton'
import TextField from '../babu/TextField'
import { createForgetPasswordURL } from '../libs/forgetPasswordHelper'
import { ga4Event } from '../libs/ga4'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import useLoginForm from '../libs/hooks/useLoginForm'

function validateLoginError(loginError) {
  if (loginError?.data?.errno) {
    return { password: '請輸入有效的帳號密碼' }
  }
  return null
}

export default function BuyerLoginForm(props) {
  const {
    memberPhone,
    showMemberLoginFields,
    loginError,
    shortURL,
    isLoading,
  } = props
  const isMember = !!memberPhone

  const {
    inputs,
    submitted,
    setSubmitted,
    onSubmit,
    onChange,
    errors: formErrors,
  } = useLoginForm({
    initialState: { username: isMember ? remove886(memberPhone) : '' },
    skipValidatePassword: !showMemberLoginFields,
    onSuccessSubmit: props.login,
  })
  const { username } = inputs

  const combinedErrors = Object.assign(
    formErrors,
    validateLoginError(loginError),
  )

  const [passwordShown, setPasswordShown] = useState(false)

  useEffect(() => {
    if (showMemberLoginFields) {
      setSubmitted(false)
    }
  }, [showMemberLoginFields, setSubmitted])

  const forgetPasswordURL = useMemo(
    () =>
      createForgetPasswordURL(
        to886(username),
        shortURL || window.location.toString(),
      ),
    [username, shortURL],
  )

  const TextFieldEndIcon = iconName => ({
    name: iconName,
    onClick: () => setPasswordShown(!passwordShown),
  })

  useGA4Pageview('slash_login_all_user_enter', showMemberLoginFields)

  return (
    <form
      className="member-login-info pt-l"
      autoComplete="off"
      onSubmit={onSubmit}>
      <TextField
        label="手機號碼"
        placeholder="09xx-xxx-xxx"
        autoComplete="off"
        name="username"
        type="tel"
        disabled={isMember}
        value={username.trim()}
        onChange={isMember ? null : onChange}
        error={
          submitted && combinedErrors.username ? combinedErrors.username : ''
        }
      />
      {showMemberLoginFields ? (
        <TextField
          containerClassName="mt-m"
          label="密碼"
          placeholder="密碼"
          autoComplete="off"
          name="password"
          endIcon={
            passwordShown
              ? TextFieldEndIcon('eyes')
              : TextFieldEndIcon('eyesclosed')
          }
          inputType={passwordShown ? 'text' : 'password'}
          value={inputs.password}
          onChange={onChange}
          error={
            submitted && combinedErrors.password ? combinedErrors.password : ''
          }
        />
      ) : null}
      <BulletButton
        variant="solid"
        className="mt-m"
        type="submit"
        loading={isLoading}
        disabled={!inputs.username}>
        {showMemberLoginFields ? <p>登入</p> : <p>下一步</p>}
      </BulletButton>
      {showMemberLoginFields ? (
        <p className="babu-text-paragraph mt-l text-center text-text500 underline cursor-pointer">
          <a
            href={forgetPasswordURL}
            onClick={e => {
              e.preventDefault()
              ga4Event('slash_login_forgetpassword')
              setTimeout(() => {
                window.location.href = forgetPasswordURL
              }, 10)
            }}>
            忘記密碼
          </a>
        </p>
      ) : null}
    </form>
  )
}
